import { uploadActivityDocument } from '@packages/api/endpoints/activity-document.js';

/**
 * Uploads a list of queued files to a newly-created activity.
 * Runs uploads in series to avoid overwhelming the server.
 * Returns an array of errors (one per failed file) - caller decides whether to surface them.
 */
export async function uploadPendingAttachments(
  accountId: string,
  activityId: string,
  files: File[],
): Promise<Array<{ filename: string; error: string }>> {
  const errors: Array<{ filename: string; error: string }> = [];

  for (const file of files) {
    try {
      await uploadActivityDocument(accountId, activityId, file);
    } catch (err) {
      errors.push({
        filename: file.name,
        error: err instanceof Error ? err.message : 'Upload failed',
      });
    }
  }

  return errors;
}
